// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed","826":"text","946":"dynamic-content"}[chunkId] + "." + {"180":"addf1551e4a3695695ce","303":"11741f7220cf39ba84c0","495":"cfe7e854fcf6043c063d","826":"ad4c8b9419e1025f1e7f","946":"48eec1b8db66c48fcf56"}[chunkId] + ".js";
};